import React from 'react';

import { ActionIcon, Group, Tooltip } from '@mantine/core';
import { IconNumber123, IconPercentage } from '@tabler/icons-react';

import { DisplayType } from '../types/experiment';

const disabledBackgroundColor = 'lightgrey';
const disabledIconColor = 'black';
const enabledBackgroundColor = '#337ab7';
const enabledIconColor = 'white';
const hoverBackgroundColor = 'lightblue';

const toggleButtonSize = 'lg';

interface PercentageToggleInput {
  displayType: DisplayType;
  setDisplayType: React.Dispatch<React.SetStateAction<DisplayType>>;
}

export default function CountPercentageToggle({ displayType, setDisplayType }: PercentageToggleInput) {
  return (
    <Group>
      <Tooltip label="Percentage">
        <ActionIcon
          size={toggleButtonSize}
          radius={toggleButtonSize}
          onClick={() => {
            if (displayType === DisplayType.COUNT) {
              setDisplayType(DisplayType.PERCENTAGE);
            }
          }}
          color={displayType === DisplayType.PERCENTAGE ? enabledBackgroundColor : disabledBackgroundColor}
          style={{ '--ai-hover': hoverBackgroundColor } as React.CSSProperties}
        >
          <IconPercentage color={displayType === DisplayType.PERCENTAGE ? enabledIconColor : disabledIconColor} />
        </ActionIcon>
      </Tooltip>
      <Tooltip label="Count">
        <ActionIcon
          size={toggleButtonSize}
          radius={toggleButtonSize}
          onClick={() => {
            if (displayType === DisplayType.PERCENTAGE) {
              setDisplayType(DisplayType.COUNT);
            }
          }}
          color={displayType === DisplayType.COUNT ? enabledBackgroundColor : disabledBackgroundColor}
          style={{ '--ai-hover': hoverBackgroundColor } as React.CSSProperties}
        >
          <IconNumber123 color={displayType === DisplayType.COUNT ? enabledIconColor : disabledIconColor} />
        </ActionIcon>
      </Tooltip>
    </Group>
  );
}
